"use client";
import {
  useDisclosureStoreProps
} from "./H5Z3PUKM.js";
import {
  useStore
} from "./SOQQIDO4.js";

// src/dialog/dialog-store.ts
import * as Core from "@ariakit/core/dialog/dialog-store";
function useDialogStoreProps(store, update, props) {
  return useDisclosureStoreProps(store, update, props);
}
function useDialogStore(props = {}) {
  const [store, update] = useStore(Core.createDialogStore, props);
  return useDialogStoreProps(store, update, props);
}

export {
  useDialogStoreProps,
  useDialogStore
};
